
module dgUtils {

    export interface IDgQueryObjectToDotNotionFIlter extends Function {
        (links: dg.restfulApi.Links, relsIn: string | Array<string>): dg.restfulApi.Link[];
    }

    function dgQueryObjectToDotNotion($filter: dgUtils.IFilterService): IDgQueryObjectToDotNotionFIlter {
        return (links: dg.restfulApi.Links, relsIn: string | Array<string>) => {
            var rels = angular.isArray(relsIn) ? <Array<string>>relsIn : [<string>relsIn];
            return $filter('filter')((Object as any).values(links), (link: dg.restfulApi.Link, index) => {
                return rels.indexOf(link.rel) != -1;
            });
        }
    } 
    angular.module('dgUtils')
        .filter('dgQueryObjectToDotNotion', ['$filter', dgQueryObjectToDotNotion]);
}